import React from 'react'
import SoftUITabs from './components/SoftUITabs/SoftUITabs.js'
import Category from './components/Tabs/Category.js';
import AddOns from './components/Tabs/AddOns.js';

const SettingINFO = () => {
  const tabsData = [
    // { label: 'Category', content: <Category  /> },
    { label: 'Add Ons', content: <AddOns  /> },
  ];

  return (
    <div>
         <SoftUITabs tabsData={tabsData}/>
    </div>
  )
}

export default SettingINFO